(function () {
  const isKwikMode = () => window.cartIntegrationPriority === 'kwik';
  const defaultRefreshCart = window.refreshSlideCart;

  const dispatchCartRefresh = (cart) => {
    const detail = cart ? { cart } : {};
    ['cart:updated', 'cart:refresh', 'cart.requestComplete', 'ajaxCart.afterCartLoad'].forEach((eventName) => {
      document.dispatchEvent(new CustomEvent(eventName, { detail }));
      window.dispatchEvent(new CustomEvent(eventName, { detail }));
    });
  };

  const getCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Cart refresh failed with ${response.status}`);
    return response.json();
  };

  const closeSlideCart = () => {
    const slideCart = document.querySelector('#slidecarthq');
    if (slideCart) {
      slideCart.classList.remove('open', 'checkpoint');
      slideCart.style.display = 'none';
    }

    document.querySelector('.slidecarthq-overlay')?.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
  };

  const openKwikCart = () => {
    const apiOpened = [
      () => window.KwikCart?.open?.(),
      () => window.kwikCart?.open?.()
    ].some((callback) => {
      try {
        return callback() !== undefined;
      } catch (error) {
        console.warn('[KwikCartPriority] Kwik API open failed.', error);
        return false;
      }
    });

    if (apiOpened) return true;

    const trigger =
      document.querySelector('[data-open-cart]')
      || document.querySelector('.kwik-minicart-block')
      || document.querySelector('[data-kwik="minicart"]');

    if (!trigger) {
      console.warn('[KwikCartPriority] Kwik minicart trigger was not found.');
      return false;
    }

    trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    return true;
  };

  const refreshAndOpenKwik = async () => {
    let cart = null;

    try {
      cart = await getCart();
    } catch (error) {
      console.warn('[KwikCartPriority] Cart refresh failed.', error);
    }

    dispatchCartRefresh(cart);
    closeSlideCart();
    window.setTimeout(() => {
      openKwikCart();
      window.setTimeout(closeSlideCart, 250);
    }, 80);

    return cart;
  };

  const addCartForm = async (form) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw await response.json().catch(() => ({}));
    return response.json();
  };

  const setFormLoading = (button, isLoading) => {
    if (!button) return;

    button.toggleAttribute('aria-disabled', isLoading);
    button.disabled = isLoading;
    button.classList.toggle('loading', isLoading);
    button.querySelector('.loading__spinner, .loading-overlay__spinner, .spinner')?.classList.toggle('hidden', !isLoading);
  };

  window.refreshSlideCart = function refreshSlideCart(options = {}) {
    if (!isKwikMode()) {
      return typeof defaultRefreshCart === 'function'
        ? defaultRefreshCart(options)
        : undefined;
    }

    return refreshAndOpenKwik();
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!isKwikMode()) return;

      const cartIcon = event.target.closest('#cart-icon-bubble');
      if (!cartIcon) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      refreshAndOpenKwik();
    },
    true
  );

  document.addEventListener(
    'wheel',
    (event) => {
      if (!isKwikMode()) return;

      const kwikCart = event.target.closest(
        '.kwik-minicart, .kwik-minicart-block, [data-kwik="minicart"], [class*="kwik"], [id*="kwik"]'
      );

      if (!kwikCart) return;

      event.stopPropagation();
      event.stopImmediatePropagation();
    },
    true
  );

  const getInstantVariantId = (trigger) => (
    trigger.getAttribute('data-instant-action-variant-id')
    || trigger.closest('[data-instant-form-variant-id]')?.getAttribute('data-instant-form-variant-id')
    || trigger.closest('form')?.getAttribute('data-instant-form-variant-id')
    || trigger.getAttribute('href')?.match(/\/cart\/(\d+):/)?.[1]
  );

  const setInstantLoading = (trigger, isLoading) => {
    trigger.classList.toggle('kwik-loading', isLoading);
    trigger.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  };

  document.addEventListener(
    'click',
    async (event) => {
      if (!isKwikMode()) return;

      const addButton = event.target.closest('button[name="add"], button[type="submit"].quick_add__submit, .quick_add__submit');
      const form = addButton?.closest('form[action="/cart/add"], form[action*="/cart/add"]');
      if (!form || form.dataset.kwikPrioritySubmitting === 'true') return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      form.dataset.kwikPrioritySubmitting = 'true';
      setFormLoading(addButton, true);

      try {
        await addCartForm(form);
        await refreshAndOpenKwik();
      } catch (error) {
        console.error('[KwikCartPriority] Cart form add-to-cart failed.', error);
      } finally {
        setFormLoading(addButton, false);
        delete form.dataset.kwikPrioritySubmitting;
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    async (event) => {
      if (!isKwikMode()) return;

      const form = event.target.closest('form[action="/cart/add"], form[action*="/cart/add"]');
      if (!form || form.dataset.kwikPrioritySubmitting === 'true') return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const button = form.querySelector('button[name="add"], button[type="submit"], .quick_add__submit');
      form.dataset.kwikPrioritySubmitting = 'true';
      setFormLoading(button, true);

      try {
        await addCartForm(form);
        await refreshAndOpenKwik();
      } catch (error) {
        console.error('[KwikCartPriority] Cart form submit failed.', error);
      } finally {
        setFormLoading(button, false);
        delete form.dataset.kwikPrioritySubmitting;
      }
    },
    true
  );

  document.addEventListener(
    'click',
    async (event) => {
      if (!isKwikMode()) return;

      const trigger = event.target.closest('[data-instant-action-type="add-to-instant-cart"]');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (trigger.dataset.kwikBusy === 'true') return;
      if (trigger.getAttribute('data-instant-disabled') === 'true') return;

      const variantId = getInstantVariantId(trigger);
      if (!variantId) {
        console.warn('[KwikCartPriority] Instant add-to-cart variant ID not found.');
        return;
      }

      trigger.dataset.kwikBusy = 'true';
      setInstantLoading(trigger, true);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });

        if (!response.ok) throw await response.json().catch(() => ({}));
        await refreshAndOpenKwik();
      } catch (error) {
        console.error('[KwikCartPriority] Instant add-to-cart failed.', error);
      } finally {
        setInstantLoading(trigger, false);
        delete trigger.dataset.kwikBusy;
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    async (event) => {
      if (!isKwikMode()) return;

      const form = event.target.closest('[data-instant-form-variant-id], form[action*="/cart"]');
      if (!form) return;

      const action = form.querySelector('[data-instant-action-type="add-to-instant-cart"]');
      if (!action && !form.getAttribute('data-instant-form-variant-id')) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const variantId = getInstantVariantId(action || form);
      if (!variantId) {
        console.warn('[KwikCartPriority] Instant form variant ID not found.');
        return;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });

        if (!response.ok) throw await response.json().catch(() => ({}));
        await refreshAndOpenKwik();
      } catch (error) {
        console.error('[KwikCartPriority] Instant form add-to-cart failed.', error);
      }
    },
    true
  );
}());
